import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import  { intl } from "dmsbasereact";

const DmsErrorSwal = ({ onClose, errorMessage }) => {
    Swal.fire({
      title: intl.get("Error").d("Error"),
      text:
        errorMessage ||
        intl.get("SomethingWentWrong").d("Something went wrong!"),
      icon: "error",
      confirmButtonText: intl.get("Close").d("Close"),
      customClass: {
        title: "swal2-title",
        popup: "swal2-popup",
        confirmButton: "swal2-confirm-button",
      },
      buttonsStyling: true,
      allowOutsideClick: false,
    }).then(() => {
      onClose();
    });
    return null;
};

DmsErrorSwal.propTypes = {
    onClose: PropTypes.func.isRequired,
    errorMessage: PropTypes.string.isRequired,
};

export default DmsErrorSwal;